import { type APIEvent } from "@solidjs/start/server";
import { query } from "@solidjs/router";
import { ADMIN, AUDIT } from "./constants";

import { getUserFromEvent } from "./auth.server";

//export const emailTemplates = () => import.meta.glob("../../emailTemplates/*.tsx", {	eager: true });

export * from "./cognito";
export * from "./dynamoDB";
export * from "./functions";
export * from "./pdf";
export * from "./accounts";
export * from "./server.email";
export * from "./dynamoQueries";

export const getUserInfo = async () => {
	"use server";

	return await getUserFromEvent();
};

export const getOrigin = (event: APIEvent) => {
	const headers = event.request.headers;
	//const headersObj = Object.fromEntries(headers.entries());

	const host = process.env.NODE_ENV === "development" ? 'localhost:9876' : 'rias-regs.co.uk';
	const proto =headers.get("cloudfront-forwarded-proto") || new URL(event.request.url).protocol.replace(":", "");

	return `${proto}://${host}`;
};

export const getMenu = query(async () => {
	"use server";
	let links;
	const user = await getUserFromEvent();

	if ( user?.groups?.includes( ADMIN ) || user?.groups?.includes( AUDIT ) ) {
		links = [
			{ caption: "Admin Dashboard", href: "/dashboard/admin" },
			{ caption: "Subscriptions", href: "/dashboard/admin/subscriptions" },
			{ caption: "Users", href: "/dashboard/admin/users" },
			{ caption: "Approved Bodies", href: "/dashboard/admin/approved-bodies" },
			// Titles the page header without adding a nav item.
			{ caption: "Scheme Statistics", href: "/dashboard/admin/stats", inMenu: false },
		];
	} else {
		links = [
			{ caption: "Home", href: "/dashboard" },
			{ caption: "Projects", href: "/dashboard/projects", exCPD: true },
			{ caption: "Account", href: "/dashboard/account" },
			{ caption: "Log Book", href: "/dashboard/logbook" },
			{ caption: "Assessment", href: "/dashboard/exams", inMenu: false },
		];
	}

	return { links };

}, "getMenu");
